export function groupFontsByFamily(fonts) {
  const fontGroups = {};

  fonts.forEach(font => {
    const family = splitAtLastHyphen(font.family)[0];

    if (!fontGroups[family]) {
      fontGroups[family] = [];
    }

    fontGroups[family].push(font);
  });
  return Object.values(fontGroups);
}

export function splitAtLastHyphen(str) {
  const lastHyphenIndex = str.lastIndexOf('-');


  if (lastHyphenIndex === -1) {
    return [str];
  }

  const part1 = str.substring(0, lastHyphenIndex);
  const part2 = str.substring(lastHyphenIndex + 1);

  return [part1, part2];
}

export function getFontStyleFromTempDiv(fontName, file) {
  const fontURL = URL.createObjectURL(file);
  const styleSheet = document.createElement('style');
  styleSheet.innerHTML = `
    @font-face {
      font-family: '${fontName}';
      src: url('${fontURL}');
    }
  `;
  document.head.appendChild(styleSheet);
  // Test elemanı oluştur
  const testElement = document.createElement('span');
  testElement.textContent = 'Test';
  testElement.style.fontFamily = fontName;
  document.body.appendChild(testElement);

  // Stil bilgilerini kontrol et
  const computedStyle = window.getComputedStyle(testElement);
  const fontStyle = computedStyle.fontStyle;
  // // Temizle
  // document.body.removeChild(testElement);
  // document.head.removeChild(styleSheet);
  
  URL.revokeObjectURL(fontURL);
  
  return fontStyle;
}